import React, { Fragment } from 'react';
import { Clock, Heart, AlertCircle, CheckCircle2, Moon, Sun, Sunrise } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-slate-900 border-t border-slate-800" data-id="element-1">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-2">
        <div className="bg-slate-800/30 rounded-3xl p-8 md:p-12 border border-slate-800" data-id="element-3">
          <div className="flex items-center space-x-3 mb-6" data-id="element-4">
            <div className="p-3 bg-red-500/10 rounded-xl" data-id="element-5">
              <AlertCircle className="w-8 h-8 text-red-400" data-id="element-6" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-7">
              La cama no es un ring: es tu base
            </h2>
          </div>

          <div className="space-y-6 text-lg text-slate-300 leading-relaxed" data-id="element-8">
            <p data-id="element-9">
              Hay una parte de la noche que nadie te prepara a manejar. No es
              cuando se acuestan.
            </p>
            <p className="font-medium text-white border-l-4 border-amber-500 pl-4" data-id="element-10">
              Es cuando se despiertan… y tú ya sabes lo que viene: Mirada
              perdida. Respiración rara.
              <br data-id="element-11" />
              <span className="italic text-amber-200/80" data-id="element-12">
                "Ya no voy a poder dormir."
              </span>
            </p>
            <p data-id="element-13">Y en tu cabeza: otra vez no…</p>
            <p data-id="element-14">
              Si tú cuidas a alguien de 65+ y cada noche se volvió una
              mini-crisis, esto no es para "dormir perfecto". Es para que esa
              persona (y tú) recuperen algo que hoy se perdió:{' '}
              <span className="text-white font-bold" data-id="element-15">control</span>.
            </p>
          </div>

          <div className="mt-12 mb-8 text-center" data-id="element-16">
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-6" data-id="element-17">
              Lo que nos mandan por WhatsApp
            </h3>
            <div className="max-w-[320px] mx-auto rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-slate-700/50" data-id="element-18">
              <img src="https://cdn.magicpatterns.com/uploads/bnq1Btd19h1GTukf6m998k/wha4.jpg" alt="Testimonio de cliente por WhatsApp" className="w-full h-auto object-cover" data-id="element-19" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}
export function SolutionSection() {
  return <section className="py-20 bg-slate-950" data-id="element-20">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-21">
        <div className="text-center mb-16" data-id="element-22">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-23">
            No es "falta de sueño". <br data-id="element-24" />
            <span className="text-indigo-400" data-id="element-25">Es el ciclo miedo→insomnio</span>
          </h2>
          <p className="text-xl text-slate-400" data-id="element-26">
            Te presento el mecanismo de las 3 Ventanas de Sueño
          </p>
        </div>

        <div className="space-y-6" data-id="element-27">
          <div className="flex flex-col md:flex-row gap-6 bg-slate-900 p-6 rounded-2xl border border-slate-800 hover:border-indigo-500/30 transition-colors" data-id="element-28">
            <div className="flex-shrink-0" data-id="element-29">
              <div className="w-16 h-16 rounded-full bg-amber-500/10 flex items-center justify-center" data-id="element-30">
                <Sun className="w-8 h-8 text-amber-500" data-id="element-31" />
              </div>
            </div>
            <div data-id="element-32">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-33">
                1. Tarde: Bajas activación
              </h3>
              <p className="text-slate-400" data-id="element-34">
                Sacas preocupaciones de la cama antes de que llegue la noche.
                Preparamos el terreno.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 bg-slate-900 p-6 rounded-2xl border border-slate-800 hover:border-indigo-500/30 transition-colors" data-id="element-35">
            <div className="flex-shrink-0" data-id="element-36">
              <div className="w-16 h-16 rounded-full bg-indigo-500/10 flex items-center justify-center" data-id="element-37">
                <Moon className="w-8 h-8 text-indigo-400" data-id="element-38" />
              </div>
            </div>
            <div data-id="element-39">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-40">
                2. Noche: Rutina de 7 minutos
              </h3>
              <p className="text-slate-400" data-id="element-41">
                Una rutina mínima para entrar al sueño sin negociar. Simple,
                repetible y efectiva.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-6 bg-slate-900 p-6 rounded-2xl border border-slate-800 hover:border-indigo-500/30 transition-colors ring-1 ring-amber-500/20" data-id="element-42">
            <div className="flex-shrink-0" data-id="element-43">
              <div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center" data-id="element-44">
                <Clock className="w-8 h-8 text-red-400" data-id="element-45" />
              </div>
            </div>
            <div data-id="element-46">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-47">
                3. Despertar: Protocolo 3AM
              </h3>
              <p className="text-slate-400" data-id="element-48">
                El paso a paso exacto para cuando abren los ojos en la
                madrugada. Sin pánico, sin improvisar.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
export function DeliverablesSection() {
  const items = ['Rutina mínima de 7 minutos (lista, sin complicaciones)', 'Protocolo 3AM con dos rutas (me quedo / salgo 7 minutos)', 'Guiones mentales listos (miedo, enojo, tristeza)', 'Ajustes para siestas, café, líquidos y recaídas', 'Plantillas imprimibles: checklist + diario 14 días', 'Guía para cuidadores: qué decir / qué NO decir'];
  return <section className="py-20 bg-slate-900" data-id="element-49">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-50">
        <div className="bg-gradient-to-br from-indigo-900/20 to-slate-900 rounded-3xl p-8 md:p-16 border border-indigo-500/20" data-id="element-51">
          <h2 className="text-3xl font-bold text-white mb-10 text-center" data-id="element-52">
            ¿Qué incluye el Protocolo?
          </h2>

          <div className="grid md:grid-cols-2 gap-x-6 gap-y-8" data-id="element-53">
            {items.map((item, idx) => <Fragment key={idx} data-id="element-54">
                <div className="flex flex-col space-y-4" data-id="element-55">
                  <div className="flex items-start space-x-4" data-id="element-56">
                    <CheckCircle2 className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" data-id="element-57" />
                    <span className="text-lg text-slate-200" data-id="element-58">{item}</span>
                  </div>
                </div>
                {item.includes('Guiones mentales') && <div className="col-span-1 md:col-span-2 flex flex-col items-center md:items-end mt-8 mb-4 pt-12 border-t border-slate-800/50 w-full" data-id="element-59">
                    <h4 className="text-xl font-bold text-white mb-8 text-center md:text-right w-full" data-id="element-60">
                      Lo que nos escriben después de probarlo:
                    </h4>
                    <div className="flex flex-col sm:flex-row gap-6 justify-center md:justify-end items-start w-full" data-id="element-61">
                      <div className="w-full max-w-[280px] rounded-2xl overflow-hidden shadow-xl shadow-black/30 border border-slate-700/50" data-id="element-62">
                        <img src="https://cdn.magicpatterns.com/uploads/fgqrcxn2vTni7vAvpLt5QQ/wha1.jpg" alt="Testimonio sobre guiones mentales" className="w-full h-auto object-cover" data-id="element-63" />
                      </div>
                      <div className="w-full max-w-[280px] rounded-2xl overflow-hidden shadow-xl shadow-black/30 border border-slate-700/50" data-id="element-64">
                        <img src="https://cdn.magicpatterns.com/uploads/4xLWsPMSg5ZoULbcEe7pmi/wha4.jpg" alt="Testimonio adicional" className="w-full h-auto object-cover" data-id="element-65" />
                      </div>
                    </div>
                  </div>}
              </Fragment>)}
          </div>
        </div>
      </div>
    </section>;
}